import { TIPO_ITENS } from 'src/utils/constants';

export const TIPO_ENTIDADE_COMENTARIO = {
  OBJETIVO_OKR: 8,
  CHAVE_RESULTADO_OKR: 9,
  PROJETOS_AGEIS_ATIVIDADE: 11,
};

export const extractPeriodoDescricao = (item) => {
  if (!item) return null;

  if (item.descricaoPeriodo) return item.descricaoPeriodo;
  if (item.periodoDescricao) return item.periodoDescricao;
  if (item.periodo && item.ano) return `${item.periodo}/${item.ano}`;
  if (item.periodo) return item.periodo;

  return null;
};

export const buildComentarioDialogTitle = (intl, nome, periodo) => {
  return [nome, periodo].filter(Boolean).join(' - ');
};

export const getTipoEntidadeComentario = (tipoItemId) => {
  if (!tipoItemId) return null;

  switch (tipoItemId) {
    case TIPO_ITENS.INDICADOR:
      return 2;
    case TIPO_ITENS.PARAMETRO:
      return 4;
    case TIPO_ITENS.OBJETIVO_ESTRATEGICO:
      return 3;
    case TIPO_ITENS.PROJETO:
      return 5;
    default:
      return null;
  }
};

export const isEmptyComment = (value) => {
  if (!value) return true;
  return (
    String(value)
      .replace(/@\[\d+\]\{[^}]+\}/g, 'x')
      .replace(/<[^>]*>/g, '')
      .trim() === ''
  );
};

const ALLOWED_TAGS = new Set([
  'P',
  'BR',
  'STRONG',
  'B',
  'EM',
  'I',
  'U',
  'S',
  'STRIKE',
  'H1',
  'H2',
  'BLOCKQUOTE',
  'OL',
  'UL',
  'LI',
  'A',
  'SPAN',
]);

const isSafeHref = (href) => {
  if (!href) return false;
  const value = String(href).trim();
  return /^(https?:|mailto:)/i.test(value);
};

export const sanitizeCommentHtml = (html) => {
  if (!html || typeof document === 'undefined') return html || '';

  const wrap = document.createElement('div');
  wrap.innerHTML = String(html);

  const clean = (node) => {
    [...node.childNodes].forEach((child) => {
      if (child.nodeType === Node.ELEMENT_NODE) {
        if (!ALLOWED_TAGS.has(child.tagName)) {
          const parent = child.parentNode;
          while (child.firstChild) parent.insertBefore(child.firstChild, child);
          parent.removeChild(child);
          return;
        }

        [...child.attributes].forEach((attr) => {
          const name = attr.name.toLowerCase();
          if (name.startsWith('on') || name === 'style') {
            child.removeAttribute(attr.name);
          }
        });

        if (child.tagName === 'A') {
          const href = child.getAttribute('href');
          if (!isSafeHref(href)) child.removeAttribute('href');
        }

        if (child.tagName === 'SPAN') {
          const cls = child.getAttribute('class') || '';
          if (!cls.split(/\s+/).includes('mention-tag')) {
            child.removeAttribute('class');
            child.removeAttribute('data-mention-id');
            child.removeAttribute('data-mention-text');
          }
        }

        clean(child);
      }
    });
  };

  clean(wrap);
  return wrap.innerHTML;
};
